export enum STORAGE_CONST {
    SAVED_ROUTE = 'gtc-saved-route',
    SAVED_QUERY = 'gtc-saved-query',
    GTC_STORE = 'gtc-store',
    GTC_COUPON_STORE = 'gtc-coupon-store',
    GTR_STORE = 'gtr-store',
    BUY_STORE = 'buy-store',
    GTR_COUPON_STORE = 'gtr-coupon-store',
    LMIPRO_STORE = 'lmipro-store',
    LMIPRO_COUPON_STORE = 'lmipro-coupon-store',
    SAVED_LANGUAGE = 'saved-language',
    BUY_CHECKOUT_STORE = 'buy-flexible-store',
    LMICENTRAL_STORE = 'lmicentral-store',
    LMICENTRAL_COUPON_STORE = 'lmicentral-coupon-store',
    STORED_GA_EVENT_PREFIX = 'stored-ga-event-',
    IS_THIRD_PARTY_COOKIE_DISABLED = 'is-third-party-cookie-disabled',
    USER_TYPE = 'user-type',
}
